/* =========================================================================
   verve — section interactions (scroll reveal, counters, FAQ, size toggle)
   Re-initialises on shopify:section:load so the theme editor stays live.
   ========================================================================= */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal ------------------------------------------ */
  function initReveals(root) {
    var reveals = (root || document).querySelectorAll('.verve .reveal:not(.in)');
    if (!reveals.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    reveals.forEach(function (el) { io.observe(el); });
    /* Safety sweep: anything already above the fold reveals immediately */
    reveals.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add('in');
    });
  }

  /* ---------- Animated counters --------------------------------------- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var decimals = (el.getAttribute('data-dec') | 0);
    if (reduce) { el.textContent = target.toFixed(decimals).replace('.', ','); return; }
    var dur = 1400, start = null;
    function tick(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(decimals).replace('.', ',');
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = target.toFixed(decimals).replace('.', ',');
    }
    requestAnimationFrame(tick);
  }
  function initCounters(root) {
    var counters = (root || document).querySelectorAll('.verve [data-count]:not([data-counted])');
    if (!counters.length || !('IntersectionObserver' in window)) return;
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.setAttribute('data-counted', '1');
          animateCount(e.target);
          cio.unobserve(e.target);
        }
      });
    }, { threshold: 0.6 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ---------- FAQ accordion ------------------------------------------- */
  function initFaq(root) {
    (root || document).querySelectorAll('.verve .qa:not([data-init])').forEach(function (qa) {
      qa.setAttribute('data-init', '1');
      var btn = qa.querySelector('button');
      var ans = qa.querySelector('.ans');
      if (!btn || !ans) return;
      btn.addEventListener('click', function () {
        var open = qa.getAttribute('aria-expanded') === 'true';
        qa.setAttribute('aria-expanded', open ? 'false' : 'true');
        ans.style.maxHeight = open ? '0' : ans.scrollHeight + 'px';
      });
    });
  }

  /* ---------- Flavour tile size toggle --------------------------------
     Pills carry data-vid (variant id), data-price, data-compare.
     Switching a pill updates the hidden variant input, the price row and
     the add button so the form posts the right variant to /cart/add.   */
  function initTiles(root) {
    (root || document).querySelectorAll('.verve .fcard:not([data-init]):not([data-cantile])').forEach(function (card) {
      card.setAttribute('data-init', '1');
      var opts = card.querySelectorAll('.size-opt');
      var idInput = card.querySelector('input[name="id"]');
      var priceEl = card.querySelector('.pprice b');
      var compareEl = card.querySelector('.pprice s');
      if (!opts.length) return;

      var apply = function (opt) {
        opts.forEach(function (o) {
          var on = o === opt;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (idInput && opt.dataset.vid) idInput.value = opt.dataset.vid;
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        if (compareEl) {
          if (opt.dataset.compare) {
            compareEl.textContent = opt.dataset.compare;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
      };

      opts.forEach(function (opt) {
        opt.addEventListener('click', function () { apply(opt); });
      });
      apply(card.querySelector('.size-opt.is-active') || opts[0]);
    });
  }

  /* ---------- 360° sachet sway (crossfade ping-pong) -----------------
     Markup: <div class="spin360" data-hold="1100"><img ...><img ...>...</div>
     Frames authored in sway order (e.g. 315°, 0°, 45°). Crossfades through
     them and back, gently, forever. One frame = static; reduced-motion = static. */
  function initSpin(root) {
    (root || document).querySelectorAll('.verve .spin360:not([data-init])').forEach(function (el) {
      el.setAttribute('data-init', '1');
      var imgs = el.querySelectorAll('img');
      if (imgs.length < 2 || reduce) return;   /* CSS first-child shows the front statically */
      el.classList.add('js-spin');
      imgs[0].classList.add('is-on');
      var path = [];
      for (var i = 0; i < imgs.length; i++) path.push(i);
      path = path.concat(path.slice(1, -1).reverse());   /* ping-pong */
      var hold = parseInt(el.getAttribute('data-hold') || '1100', 10);
      var idx = 0;
      setInterval(function () {
        imgs[path[idx]].classList.remove('is-on');
        idx = (idx + 1) % path.length;
        imgs[path[idx]].classList.add('is-on');
      }, hold);
    });
  }

  /* ---------- Cans flavour tiles: toggle swaps price + image -----------
     Buttons carry data-price and data-img. On init we set price only (keep the
     single-can image); on click we swap both, so picking 4-pack shows the box. */
  function initCanTiles(root) {
    (root || document).querySelectorAll('.verve .fcard[data-cantile]:not([data-ct])').forEach(function (card) {
      card.setAttribute('data-ct', '1');
      var opts = card.querySelectorAll('.size-opt');
      var img = card.querySelector('.fcard-img');
      var priceEl = card.querySelector('.pprice b');
      var origEl = card.querySelector('.pprice s');
      var apply = function (opt, swapImg) {
        opts.forEach(function (o) { o.classList.toggle('is-active', o === opt); });
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        if (origEl && opt.dataset.orig) origEl.textContent = opt.dataset.orig;
        if (swapImg && img && opt.dataset.img) img.src = opt.dataset.img;
      };
      if (!opts.length) return;
      opts.forEach(function (opt) { opt.addEventListener('click', function () { apply(opt, true); }); });
      apply(card.querySelector('.size-opt.is-active') || opts[0], true);
    });
  }

  function initAll(root) {
    initReveals(root);
    initCounters(root);
    initFaq(root);
    initTiles(root);
    initCanTiles(root);
    initSpin(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
